import type { subscription as en } from '@/i18n/locales/en/subscription';
import type { Translation } from '@/i18n/types';

export const subscription: Translation<typeof en> = {
  title: 'Subscrição',
  lead: 'Gere a tua subscrição — plano, pagamento e cancelamento.',
  dialogCancel: 'Cancelar',
  status: {
    title: 'Estado',
    active: 'Ativa',
    inactive: 'Inativa',
    tier: 'Plano',
    expires: 'Expira',
    autoRenews: 'Renova-se automaticamente',
    doesNotRenew: 'Não se renova',
    nextCharge: 'Próxima cobrança',
    blocked: 'Não podes iniciar uma subscrição web neste momento.',
  },
  plans: {
    title: 'Planos',
    monthly: 'Mensal',
    yearly: 'Anual',
    perMonth: '{{price}} / mês',
    perYear: '{{price}} / ano',
    subscribe: 'Subscrever',
    current: 'Plano atual',
    switchToYearly: 'Mudar para anual',
    switchToMonthly: 'Mudar para mensal',
    switchWarning:
      'Mudar cancela a tua subscrição atual e inicia a nova de imediato no mesmo mandato de pagamento. A sobreposição entre os dois períodos não é reembolsada — podes ser cobrado duas vezes por ela.',
    switchConfirm: 'Sim, mudar de plano',
    blocked:
      'Já tens uma subscrição ativa, por isso não é possível iniciar outro plano neste momento.',
  },
  manage: {
    title: 'Gerir',
    cancel: 'Cancelar subscrição',
    cancelConfirm: 'Sim, cancelar',
    cancelled: 'Cancelada — o acesso mantém-se até {{date}}.',
    proRataNote:
      'No plano anual, cancelar após o primeiro período de pagamento reembolsa os meses inteiros não utilizados e termina o acesso de imediato em vez de no final do período.',
    withdraw: 'Retratação (dentro de 14 dias)',
    withdrawHint:
      'Disponível durante 14 dias após o teu primeiro pagamento, uma vez, por subscrição.',
  },
  history: {
    title: 'Histórico',
    empty: 'Ainda sem compras.',
    date: 'Data',
    period: 'Período',
    channel: 'Canal',
    state: 'Estado',
    state_granted: 'Concedida',
    state_refunded: 'Reembolsada',
    state_revoked: 'Revogada',
    state_charged_back: 'Estornada',
    state_rejected: 'Rejeitada',
    invoice: 'Fatura',
    withdrawLink: 'Retratação',
    manageLink: 'Gerir na loja',
  },
  checkout: {
    title: 'Finalização de compra',
    lead: 'Revê o teu plano antes de continuar para a Mollie.',
    plan: 'Plano',
    price: 'Preço',
    consentLabel:
      'Quero que o serviço comece de imediato e compreendo que, se me retratar, pagarei proporcionalmente pela parte já utilizada.',
    start: 'Continuar para a Mollie',
    errorAlreadySubscribed: 'Já tens uma subscrição ativa.',
    errorProductUnavailable: 'Este plano não está disponível neste momento.',
  },
  return: {
    title: 'Estado do pagamento',
    waiting: 'Ainda estamos à espera da confirmação do pagamento.',
    success: 'Pagamento recebido — a tua subscrição está ativa.',
    backToSubscription: 'Voltar à tua subscrição',
  },
  withdraw: {
    title: 'Retratar-te da tua subscrição',
    lead: 'A retratação dentro do prazo de 14 dias termina o teu acesso de imediato — ao contrário do cancelamento, que se mantém até ao final do período já pago.',
    refundTypeFull: 'Vais receber um reembolso total.',
    refundTypeProRata: 'Vais receber um reembolso proporcional pela parte ainda não utilizada.',
    refundAmount: 'Valor do reembolso',
    deadline: 'Prazo',
    confirm: 'Retratar-me e terminar o acesso agora',
    confirmed: 'Retratação efetuada — {{amount}} serão reembolsados.',
    errorWindowExpired: 'O prazo de retratação de 14 dias já passou.',
    errorAlreadyWithdrawn: 'Já te retrataste desta subscrição.',
  },
};
